'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.openModal = openModal;
exports.openDeleteModal = openDeleteModal;
exports.load = load;
exports.setActiveId = setActiveId;
exports.setField = setField;
exports.create = create;
exports.remove = remove;
exports.update = update;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE = 'redux-frontend/messageTemplate/CREATE';
var CREATE_SUCCESS = 'redux-frontend/messageTemplate/CREATE_SUCCESS';
var CREATE_FAIL = 'redux-frontend/messageTemplate/CREATE_FAIL';

var DELETE = 'redux-frontend/messageTemplate/DELETE';
var DELETE_SUCCESS = 'redux-frontend/messageTemplate/DELETE_SUCCESS';
var DELETE_FAIL = 'redux-frontend/messageTemplate/DELETE_FAIL';

var LOAD = 'redux-frontend/messageTemplate/LOAD';
var LOAD_SUCCESS = 'redux-frontend/messageTemplate/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/messageTemplate/LOAD_FAIL';

var OPEN_MODAL = 'redux-frontend/messageTemplate/OPEN_MODAL';
var OPEN_DELETE_MODAL = 'redux-frontend/messageTemplate/OPEN_DELETE_MODAL';
var SET_ACTIVE_ID = 'redux-frontend/messageTemplate/SET_ACTIVE_ID';
var SET_FIELD = 'redux-frontend/messageTemplate/SET_FIELD';

var UPDATE = 'redux-frontend/messageTemplate/UPDATE';
var UPDATE_SUCCESS = 'redux-frontend/messageTemplate/UPDATE_SUCCESS';
var UPDATE_FAIL = 'redux-frontend/messageTemplate/UPDATE_FAIL';

var initialState = {
  loading: false,
  template: {},
  templates: [],
  activeId: 'new',
  openModal: false,
  openDeleteModal: false,
  creating: false,
  saving: false,
  deleting: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CREATE:
      return (0, _extends3.default)({}, state, {
        saving: true
      });
    case CREATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saving: false
      });
    case CREATE_FAIL:
      return (0, _extends3.default)({}, state, {
        saving: false
      });
    case DELETE:
      return (0, _extends3.default)({}, state, {
        deleting: true
      });
    case DELETE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        deleting: false
      });
    case DELETE_FAIL:
      return (0, _extends3.default)({}, state, {
        deleting: false
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        templates: action.result,
        loading: false
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case OPEN_MODAL:
      return (0, _extends3.default)({}, state, {
        openModal: action.open
      });
    case OPEN_DELETE_MODAL:
      return (0, _extends3.default)({}, state, {
        openDeleteModal: action.open
      });
    case SET_ACTIVE_ID:
      return (0, _extends3.default)({}, state, {
        activeId: action.activeId
      });
    case UPDATE:
      return (0, _extends3.default)({}, state, {
        saving: true
      });
    case UPDATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saving: false
      });
    case UPDATE_FAIL:
      return {
        saving: false
      };
    default:
      return state;
  }
}

function openModal() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MODAL,
    open: open
  };
}
function openDeleteModal() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_DELETE_MODAL,
    open: open
  };
}
function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/users/me/message-templates');
    }
  };
}

function setActiveId() {
  var activeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'new';

  return {
    type: SET_ACTIVE_ID,
    activeId: activeId
  };
}

function setField(name, value) {
  return {
    type: SET_FIELD,
    name: name,
    value: value
  };
}

function create(data) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/message-templates', { data: data });
    }
  };
}

function remove(id) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: function promise(client) {
      return client.del('/users/me/message-templates/' + id);
    }
  };
}

function update(id, data) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: function promise(client) {
      return client.put('/users/me/message-templates/' + id, { data: data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/messageTemplate.js
// module id = 219
// module chunks = 47